var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datepicker',{attrs:{"id":_vm.id,"name":_vm.name,"value":_vm.date,"format":_vm.format,"fullMonthName":true,"required":_vm.isRequired,"disabled-dates":_vm.disabledDates},on:{"input":function($event){return _vm.update($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }